﻿import {
  Dialog,
  DialogContent,
  DialogTitle,
  Box,
  IconButton,
} from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";
import "./AddEndpoint.css";

import NewEndpointSetup from "./NewEndpointSetup";

const AddEndpointPopup = (props) => {
  return (
    <div>
      <Dialog
        className="add-endpoint-container"
        open={props.open}
        onClose={props.onClose}
        maxWidth="xl"
        PaperProps={{
          style: {
            backgroundColor: "transparent",
            boxShadow: "none",
            width: "2000px",
            height: "1600px",
          },
        }}
        sx={{ zIndex: "1500" }}
      >
        <DialogTitle
          style={{
            display: "flex",
            justifyContent: "space-between",
            backgroundColor: "var(--primary-main)",
            color: "var(--default-light)",
            fontSize: "24px",
            borderRadius: "15px 15px 0 0",
          }}
        >
          <div style={{ display: "flex" }}>
            <div style={{ fontWeight: "var(--font-semi-bold)" }}>
              Add Endpoint
            </div>
            <div></div>
          </div>
          <IconButton
            className="closeIconButton"
            style={{ color: "var(--default-light)" }}
            onClick={props.onClose}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent className="dialogContent">
          <Box className="addEndpoint-dialogPaper">
            <NewEndpointSetup
              onCloseDialog={props.onClose}
              selectedEndpointId={props.selectedEndpointId}
              selectedEndpoint={props.selectedEndpoint}
            />
          </Box>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default AddEndpointPopup;
